import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { PrimaryCTAButton } from "../../common/Buttons";
import ChatModal from "./ChatModal";
import COLORS from "../../../assets/Colors";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import "./Timeline.css";
import EventService from "../../../services/EventService";
import useViewer from "../../../hooks/useViewer";
import LiveTickers from "../Liveresources/Tickers";
import Feedback, { HeadingContainer } from "../Liveresources/Feedback";
import VideoBox from "../../common/VideoBox";
import MenuBurger from "../../common/ActionBar/MenuBurger";
import { navigate, useLocation } from "@reach/router";
import Polling from "../../common/Polling";
import AgendaTab from "../MenuBar/Agenda";
import SpeakersTab from "../MenuBar/Speakers";
import ResourcesTab from "../MenuBar/Resources";
import VideosTab from "../MenuBar/Videos";
import HostService from "../../../services/HostService";
import useLoader from "../../../hooks/useLoader";
import PollBarChart from "../MenuBar/PollBarChart";
import GeneralGuidelinesTab from "../MenuBar/GeneralGuidelines";
import { DrawerContainer } from "../Register";
import VideoPlayer from "../../common/Video";
import CustomAudioPlayer from "../AudioPlayer/CustomAudioPlayer";
import CustomAudioPlayerImage from "../AudioPlayer/CustomAudioPlayerImage";
import FAQs from "../MenuBar/Faqs";

const JoinEvent = () => {
  const buttonRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const { userObject, setGlobalState } = useViewer();
  const [modal, setModal] = useState({ state: false });
  const [userData, setUserData] = useState();
  const location = useLocation();
  const [pollModal, setPollModal] = useState({ state: false });
  const { setLoader } = useLoader();
  const [fields, setFields] = useState({});
  const [initialState, setInitialState] = useState();

  const [pollResult, setPollResult] = useState([]);

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching live..." });
        const response = await EventService.eventInfoEventViewerLive(
          userObject?.eventId,
          "live",
        );
        setUserData(response);
        setGlobalState(response);
        setFields(response?.feedback?.feedbackForm);
        if (response?.feedback?.feedbackForm !== null) {
          if (Object.keys(response?.feedback?.feedbackForm).length !== 0) {
            setInitialState(
              Object.keys(response?.feedback?.feedbackForm).reduce(
                (acc, key) => {
                  const firstFieldType =
                    response?.feedback?.feedbackForm[key][0]?.type;
                  acc[key] =
                    firstFieldType === "checkbox"
                      ? []
                      : firstFieldType === "radio" ||
                        firstFieldType === "select"
                        ? ""
                        : "";
                  return acc;
                },
                {},
              ),
            );
          }
        }
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
        if (err.errorCode === "ER-UNAUTHORISED-USER") {
          navigate(location.pathname);
        }
      } finally {
        setLoader({ state: false });
      }
    }
    if (userObject?.eventId) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObject?.eventId]);

  useEffect(() => {
    if (userObject?.eventId) {
      const interval = setInterval(() => {
        (async function getEventInfo() {
          try {
            const response = await EventService.eventInfoEventViewerLive(
              userObject?.eventId,
              "live",
            );
            setUserData(response);
            setGlobalState(response);
            setFields(response?.feedback?.feedbackForm);
            if (
              response?.polling?.pollQuestions.filter((arr) => arr.pollResult)
                .length
            ) {
              const res = await HostService.getPollingResults(
                userObject?.eventId,
              );
              setPollResult(res?.IndividualPollResponses);
            }
            if (response) {
              if (response?.feedback?.feedbackForm !== null) {
                if (
                  Object.keys(response?.feedback?.feedbackForm).length !== 0
                ) {
                  setInitialState(
                    Object.keys(response?.feedback?.feedbackForm).reduce(
                      (acc, key) => {
                        const firstFieldType =
                          response?.feedback?.feedbackForm[key][0]?.type;
                        acc[key] =
                          firstFieldType === "checkbox"
                            ? []
                            : firstFieldType === "radio" ||
                              firstFieldType === "select"
                              ? ""
                              : "";
                        return acc;
                      },
                      {},
                    ),
                  );
                }
              }
              if (response?.livepage?.livePageSettings?.livePoll) {
                if (
                  response?.polling?.pollQuestions?.filter(
                    (item) => item?.accept === "pollsAreLive",
                  ).length &&
                  response?.polling?.pollQuestions
                    ?.filter((item) => item?.accept === "pollsAreLive")
                    .some(
                      (arr) =>
                        !localStorage
                          .getItem("pollArray")
                          .includes(arr.question),
                    )
                ) {
                  setPollModal({
                    state: true,
                    eventId: userObject?.eventId,
                    viewerId: userObject?.id,
                    userData: response?.polling?.pollQuestions
                      ?.filter((item) => item?.accept === "pollsAreLive")
                      .filter(
                        (arr) =>
                          !localStorage
                            .getItem("pollArray")
                            .includes(arr.question),
                      ),
                  });
                } else {
                  setPollModal({
                    state: false,
                  });
                }
              }
            }
          } catch (err) {
            if (err.errorCode === "ER-UNAUTHORISED-USER") {
              navigate(location.pathname);
            }
          }
        })();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [userObject?.eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  /*

  const onFormrateEvent = async () => {
    try {
      const payload = {
        eventId: String(userObject?.eventId),
        viewerId: String(userObject?.id),
        comments: text,
        rating: String(rating),
        role: "eventviewer",
      };
      // setRating(newRating);
      const response = await EventService.saveEventFeedback(payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    }
  };

  const handleRateChage = (event, newRating) => {
    setRating(newRating);
  };

  */

  const actions = [
    {
      text: "Home",
      props: {
        onClick: () => {
          navigate(`/live#home`);
        },
      },
    },
    {
      text: "Agenda",
      props: {
        onClick: () => {
          navigate("#agenda");
        },
      },
      hidden:
        userData?.event?.speakerSection?.speakersRequired &&
          userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Speakers",
      props: {
        onClick: () => {
          navigate("#speakers");
        },
      },
      hidden:
        userData?.event?.speakerSection?.speakersRequired &&
          userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Resources",
      props: {
        onClick: () => {
          navigate("#resources");
        },
      },
      hidden:
        userData?.event?.resourceSection?.resourcesRequired &&
          userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Videos",
      props: {
        onClick: () => {
          navigate("#videos");
        },
      },
      hidden:
        userData?.event?.resourceSection?.resourcesRequired &&
          userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Polling",
      props: {
        onClick: () => {
          navigate("#polling");
        },
      },
      hidden: userData?.livepage?.livePageSettings?.livePoll ? false : true,
    },
    {
      text: userData?.livepage?.livePageSettings?.generalGuidelinesLabel
        ? userData?.livepage?.livePageSettings?.generalGuidelinesLabel
        : "General Guidelines Tab",
      props: {
        onClick: () => {
          navigate("#general-guidelines-tab");
        },
      },
      hidden: userData?.livepage?.livePageSettings?.generalGuidelines
        ? false
        : true,
    },
    {
      text: "FAQs",
      props: {
        onClick: () => {
          navigate("#faqs");
        },
      },
    },
    {
      text: "Help",
      props: {
        onClick: () => {
          navigate("#help");
        },
      },
    },
    {
      text: "Feedback",
      props: {
        onClick: () => {
          navigate("#feedback");
        },
      },
      hidden:
        userData?.feedback?.feedbackForm &&
          Object.keys(userData.feedback.feedbackForm).length !== 0
          ? false
          : true,
    },
  ];

  const { resourceSection, resourceSetting, speakerSection, speakerSettings } =
    userData || {};
  const { resourcesRequired, resourcesVisibility } = resourceSection || {};
  const { speakersRequired, speakersVisibility } = speakerSection || {};

  const { galleryView } = userData?.livepage || {};
  // Define condition in a variable
  const shouldRenderResources =
    resourcesRequired &&
    (resourcesVisibility === "afterLogin" ||
      resourcesVisibility === "bothBeforeAfter");

  // Define condition in a variable
  const shouldRenderSpeakers =
    speakersRequired &&
    (speakersVisibility === "afterLogin" ||
      speakersVisibility === "bothBeforeAfter");

  const shouldRenderAgmHeader =
    userData?.general?.eventTemplate === "AGM" && galleryView?.showHeader
      ? true
      : userData?.general?.eventTemplate !== "AGM"
        ? true
        : userData?.general?.eventTemplate === "AGM" && !galleryView?.showHeader
          ? false
          : true;

  return (
    <>
      {userData?.theme?.themeNavigationBar?.navBarTreatment ===
        "alwaysVisible" &&
        shouldRenderAgmHeader && (
          <MenuBurger
            {...{ actions }}
            color={userData?.theme?.themeNavigationBar?.menuButtonTextColor}
            hoverColor={
              userData?.theme?.themeNavigationBar?.menuButtonHoverColor
            }
            menuBackgroundColor={
              userData?.theme?.themeNavigationBar?.menuButtonBgColor
            }
            activeMenuButtonBgColor={
              userData?.theme?.themeNavigationBar?.activeMenuButtonBgColor
            }
            activeMenuButtonTextColor={
              userData?.theme?.themeNavigationBar?.activeMenuButtonTextColor
            }
          />
        )}
      <Center>
        {userData?.general?.eventStatus === "inactive" &&
          (userData?.general?.playbackInfo?.playbackRequired === false ||
            !userData?.general?.playbackInfo?.playbackRequired) ? (
          <OuterContainer>
            <DrawerContainer>
              <h2>Your event is inactive</h2>
            </DrawerContainer>
          </OuterContainer>
        ) : (
          <OuterContainer
            checkAgm={userData?.general?.eventTemplate === "AGM" ? true : false}
          >
            {location.href.includes("agenda") ? (
              shouldRenderSpeakers && (
                <AgendaTab speakerSettings={speakerSettings} />
              )
            ) : location.href.includes("speakers") ? (
              shouldRenderSpeakers && (
                <SpeakersTab speakerSettings={speakerSettings} />
              )
            ) : location.href.includes("resources") ? (
              shouldRenderResources && (
                <ResourcesTab resourceSetting={resourceSetting} />
              )
            ) : location.href.includes("videos") ? (
              shouldRenderResources && (
                <VideosTab resourceSetting={resourceSetting} />
              )
            ) : location.href.includes("polling") ? (
              <PollBarChart individualPollResponses={pollResult} />
            ) : location.href.includes("feedback") ? (
              <Feedback
                fields={fields}
                initialState={initialState}
                userData={userData}
              />
            ) : location.href.includes("general-guidelines-tab") ? (
              <GeneralGuidelinesTab
                generalGuidelinesTab={
                  userData?.additionaltabs?.generalGuidelinesTab
                }
              />
            ) : location.href.toLowerCase().includes("faqs") ? (
                <FAQs data={userData?.faq || []} />
              ) : location.href.toLowerCase().includes("help") ? (
                <FAQs data={userData?.help || []} help={true} />
              )  : userData?.general?.eventStatus === "inactive" &&
              userData?.general?.playbackInfo?.playbackRequired &&
              !userData?.general?.playbackInfo?.playbackVideo?.length ? (
              <DrawerContainer>
                <h2>Playback is getting ready for this event</h2>
              </DrawerContainer>
            ) : userData?.general?.eventStatus === "inactive" &&
              userData?.general?.playbackInfo?.playbackRequired &&
              userData?.general?.playbackInfo?.playbackVideo?.length ? (
              //<Container>
                <VideoWrapper>
                  {userData?.general?.playbackInfo?.playbackVideo && (
                    <VideoPlayer
                      src={userData?.general?.playbackInfo?.playbackVideo}
                    />
                  )}
                </VideoWrapper>
              //</Container>
            ) : (
              <Container>
                {userData?.general?.eventTitle ? (
                  <HeadingContainer>
                    {/* <Header3
                      style={{
                        marginTop:
                          userData?.general?.eventTemplate === "AGM"
                            ? "0px"
                            : "18px",
                        color: userData?.theme?.themeGeneral?.titleTextColor,
                        fontFamily:
                          userData?.theme?.themeGeneral?.titleTextFont,
                        fontSize: `${userData?.theme?.themeGeneral?.titleTextFontSize}px`,
                      }}
                    >
                      {userData?.general?.eventTitle}
                    </Header3> */}
                  </HeadingContainer>
                ) : null}
                {userData?.livepage?.livePageSettings?.contentFormat === "video"
                  ? userData?.livepage?.liveStreamSettings
                    .filter((item) => item?.label === "Live Stream")
                    .map((stream) => (
                      <VideoCard>
                        <VideoBox
                          src={
                            stream?.liveStreamPlayerUrl
                              ? stream?.liveStreamPlayerUrl
                              : ""
                          }
                        />
                      </VideoCard>
                    ))
                  : userData?.livepage?.livePageSettings?.contentFormat ===
                    "audio"
                    ? userData?.livepage?.liveStreamSettings
                      .filter((item) => item?.label === "Live Stream")
                      .map((stream) => (
                        <CustomAudioPlayer
                          src={
                            stream?.liveStreamPlayerUrl
                              ? stream?.liveStreamPlayerUrl
                              : ""
                          }
                        />
                      ))
                    : userData?.livepage?.livePageSettings?.contentFormat ===
                      "audioWithStaticImage"
                      ? userData?.livepage?.liveStreamSettings
                        .filter((item) => item?.label === "Live Stream")
                        .map((stream) => (
                          <CustomAudioPlayerImage
                            image={
                              userData?.livepage?.livePageSettings
                                ?.uploadStaticImg
                            }
                            src={
                              stream?.liveStreamPlayerUrl
                                ? stream?.liveStreamPlayerUrl
                                : ""
                            }
                          />
                        ))
                      : null}
                <>
                  <HeadingContainer>
                    {userData?.livepage?.livePageSettings?.textQuestion ? (
                      <PrimaryCTAButton
                        style={{
                          width: "auto",
                          marginRight: "5px",
                          margin: "15px",
                        }}
                        ref={buttonRef}
                        onClick={() => setModal({ state: true })}
                      >
                        {userData?.livepage?.livePageSettings?.textQuestionLabel
                          ? userData?.livepage?.livePageSettings
                            ?.textQuestionLabel
                          : "Text Question"}
                      </PrimaryCTAButton>
                    ) : null}
                    {userData?.livepage?.livePageSettings?.videoQuestion ? (
                      <PrimaryCTAButton
                        style={{
                          width: "auto",
                        }}
                        ref={buttonRef}
                      >
                        {userData?.livepage?.livePageSettings
                          ?.videoQuestionLabel
                          ? userData?.livepage?.livePageSettings
                            ?.videoQuestionLabel
                          : "Video Question"}
                      </PrimaryCTAButton>
                    ) : null}
                  </HeadingContainer>
                </>
                {modal?.state && <ChatModal {...{ modal, setModal }} />}
                {pollModal?.state && (
                  <Polling {...{ pollModal, setPollModal }} />
                )}
              </Container>
            )}
          </OuterContainer>
        )}
        {userData?.livepage?.livePageSettings?.liveTickers &&
          userData?.tickers?.tickerSettings?.tickerVisibility === "tickerLive" ? (
          <LiveTickers
            messages={[userData?.tickers?.tickerSettings?.tickerText]}
            speed={userData?.tickers?.tickerSettings?.tickerSpeed}
            direction={
              userData?.tickers?.tickerSettings?.tickerDirection ===
                "rightToLeft"
                ? "right"
                : userData?.tickers?.tickerSettings?.tickerDirection ===
                  "leftToRight"
                  ? "left"
                  : "center"
            }
            position={
              userData?.tickers?.tickerSettings?.tickerPosition ===
                "bottomOfThePage"
                ? "bottom"
                : userData?.tickers?.tickerSettings?.tickerPosition ===
                  "topOfThePage"
                  ? "top"
                  : "center"
            }
            tickerTextColor={userData?.tickers?.tickerSettings?.tickerTextColor}
            tickerBgColor={userData?.tickers?.tickerSettings?.tickerBgColor}
            checkIfTrue={
              userData?.livepage?.galleryView?.showFooter ? true : false
            }
          />
        ) : null}
      </Center>
    </>
  );
};

export default JoinEvent;

export const OuterContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  padding-top: ${({ checkAgm }) => (checkAgm ? "0px" : "10px")};
  padding-bottom: 10px;
  
  @media ${theme.breakpoints.sm_up} {
   min-height: 90vh;
   margin-top:2vh;
   padding-bottom:3vh;
  }
  @media (orientation: landscape) and (max-height: 500px) {
    position: absolute;
    max-height:100%;
    top:1%;
    overflow:scroll;
    padding-top:10vh;
    padding-bottom:10vh;
  }
`;


export const Container = styled.div`
  border-radius: 11px;
  width: 100%;
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  //height:75vh;
  //justify-content:center;
  overflow:hidden;
  @media (max-width: 600px) {
    width: 90%;
    padding: 30px 30px;
  }
  @media ${theme.breakpoints.sm_up} {
    width: 100%;
  }
`;

const VideoCard = styled.div`
  display: flex;
  //margin: 28px 0;
  margin-top:50px;
  width: 100%;
 flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  @media${theme.breakpoints.sm_up} {
    width: 70%;
    justify-content: center;
  align-items: center;
  //margin: 28px 0 !important;
   flex-direction: row; 
  }
  @media ${theme?.breakpoints?.lg_up} {
   justify-content: space-between;
    align-items: center;
  }
   @media (orientation: landscape) and (max-height: 500px) {
    margin-top: 15vh;
    width: 85vw;
    height: auto;
    max-height: none;
    overflow: visible;
   
  }
`;

// const VideoWrapper = styled.div`
//   width: 80%;
//   border-radius: 6px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   @media ${theme?.breakpoints?.lg_up} {
//     justify-content: flex-start;
//   }
// `;

const VideoWrapper = styled.div`
  width: 70%;
  margin: 2% 14%;
  padding: 4%;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  // @media ${theme.breakpoints.sm_up} {
  //   width: 90%;
  //   padding-right: 18px;
  // }

  // @media ${theme.breakpoints.lg_up} {
  //   width: 85%;
  //   margin-left: 68px;
  // }
  @media (orientation: landscape) and (max-height: 500px) {
    top: 25vh;
    max-height:80%;
    width: 75vw;
    bottom: 5%;
    overflow:scroll;
  }
   /* ✅ Add your exact block right here */
    @media (orientation: portrait) and (max-width: 500px) {
      margin-top: 10vh;
    }
`;


export const AboutUsBody = styled.section`
  /* height: 663px; */
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    height: unset;
  }
`;
export const GreySection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 60px 0 60px 0;
  align-items: center;
  background-color: #f9f9f9;
  width: 100vw;
`;
export const WhiteSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
`;

export const H2 = styled.h2`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 22px;
  margin-bottom: 32px;
  cursor: default;
  padding: 0 20px;
  margin: 0 auto;
  @media (max-width: 1024px) {
    font-size: 24px;
    text-align: center;
  }
`;

export const BodyWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 1%;
  color: ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontBold};
  width: 100%;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Loader = styled.div`
  align-items: center;
  justify-content: center;
`;

const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  @media only screen and (max-width: 767px) {
    margin-left: 12px;
  }
`;
